export default {
  index: [
    {
      path: '/BuinessproType',
      component: resolve => require(['./BuinessproTypeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/businessType/_router.js